(() => {
  const root = document.getElementById('PartnersWhatsApp');
  if (!root) return;

  const closePartnersHelpMenu = () => {
    const menu = document.getElementById('PartnersHelpMenu');
    const launcher = document.getElementById('PartnersHelpLauncher');

    if (menu) menu.hidden = true;
    if (launcher) launcher.setAttribute('aria-expanded', 'false');
  };

  const fireJoyDeeplink = () => {
    try {
      if (window.location.hash === '#joy-home') {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }

      const link = document.createElement('a');
      link.href = '#joy-home';
      link.hidden = true;
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.setTimeout(() => {
        if (window.location.hash === '#joy-home') {
          window.history.replaceState(null, '', window.location.pathname + window.location.search);
        }
      }, 1500);
    } catch (error) {
      console.warn('Partners Rewards: Joy deeplink could not open yet.', error);
    }
  };

  const openJoyRewards = () => {
    closePartnersHelpMenu();
    fireJoyDeeplink();

    let attempts = 0;
    let opened = false;

    const trigger = () => {
      if (opened) return;

      if (typeof window.avadaJoyTrigger === 'function') {
        try {
          window.avadaJoyTrigger();
          opened = true;
          return;
        } catch (error) {
          console.warn('Partners Rewards: Joy drawer could not open yet.', error);
        }
      }

      attempts += 1;
      if (attempts < 40) {
        window.setTimeout(trigger, 250);
      }
    };

    window.addEventListener('joy:ready', trigger, { once: true });
    trigger();
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const rewardsTrigger = target ? target.closest('[data-partners-rewards-open]') : null;
    if (!rewardsTrigger) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'partners_help_rewards_click',
      page_location: window.location.href
    });

    openJoyRewards();
  }, true);

  const modal = document.getElementById('PartnersWhatsAppModal');
  const dialog = document.getElementById('PartnersWhatsAppDialog');
  const form = document.getElementById('PartnersWhatsAppLeadForm');
  const closeButton = root.querySelector('[data-partners-whatsapp-close]');
  const pageUrlField = document.getElementById('PartnersWhatsAppPageUrl');
  const phone = '27828242946';
  const captureFrame = root.querySelector('iframe[name="PartnersWhatsAppCapture"]');
  const directWhatsAppSelector = [
    '[data-partners-whatsapp-open]',
    `a[href*="wa.me/${phone}"]`,
    `a[href*="api.whatsapp.com/send"][href*="${phone}"]`
  ].join(',');

  let previousFocus = null;

  const sendDataLayerEvent = (eventName, extra = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...extra
    });
  };

  const getFocusable = () => Array.from(
    dialog.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )
  ).filter((element) => !element.hidden && element.offsetParent !== null);

  const openModal = (event) => {
    if (event) event.preventDefault();

    previousFocus = document.activeElement;
    if (pageUrlField) pageUrlField.value = window.location.href;

    modal.hidden = false;
    document.documentElement.classList.add('partners-wa-open');

    window.requestAnimationFrame(() => {
      const firstField = document.getElementById('PartnersWhatsAppName');
      (firstField || dialog).focus();
    });

    sendDataLayerEvent('partners_whatsapp_form_open', {
      page_location: window.location.href
    });
  };

  const closeModal = () => {
    modal.hidden = true;
    document.documentElement.classList.remove('partners-wa-open');

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const trigger = target ? target.closest(directWhatsAppSelector) : null;
    if (!trigger) return;

    openModal(event);
  });

  if (closeButton) closeButton.addEventListener('click', closeModal);

  if (modal) {
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
  }

  document.addEventListener('keydown', (event) => {
    if (!modal || modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key === 'Tab') {
      const focusable = getFocusable();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  if (!form) return;

  if (captureFrame) {
    form.setAttribute('target', captureFrame.name);
  }

  form.addEventListener('submit', (event) => {
    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
      return;
    }

    if (pageUrlField) pageUrlField.value = window.location.href;
    if (captureFrame) form.setAttribute('target', captureFrame.name);

    const name = document.getElementById('PartnersWhatsAppName').value.trim();
    const email = document.getElementById('PartnersWhatsAppEmail').value.trim();
    const reason = document.getElementById('PartnersWhatsAppReason').value.trim();
    const details = document.getElementById('PartnersWhatsAppMessage').value.trim();

    const message = [
      'Hi Partners Hair,',
      '',
      `Name: ${name}`,
      `Email: ${email}`,
      `Reason for contact: ${reason}`,
      '',
      'Enquiry:',
      details,
      '',
      `Page: ${window.location.href}`
    ].join('\n');

    const whatsAppUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    const whatsAppWindow = window.open(whatsAppUrl, '_blank');
    if (whatsAppWindow) whatsAppWindow.opener = null;

    sendDataLayerEvent('partners_whatsapp_form_submit', {
      enquiry_reason: reason,
      page_location: window.location.href
    });

    if (!whatsAppWindow) {
      window.setTimeout(() => {
        window.location.assign(whatsAppUrl);
      }, 650);
    }

    window.setTimeout(closeModal, 250);
    window.setTimeout(() => form.reset(), 1500);
  });
})();
